/**
 * Created by zsalzman on 11/9/16.
 */
import contentful from 'contentful';
import userLocale from 'browser-locale';
import { log } from 'util';

let instance = null;
class CmsService {

  constructor() {
    if (!instance) {
      instance = this;
    }
    this.locale = 'en-US';
    this.entries = {};
    return instance;
  }

  init(contentfulSpace, contentfulAccessToken) {
    this.contentfulClient = contentful.createClient({
      space: contentfulSpace,
      accessToken: contentfulAccessToken
    });
    this.setLocale();
  }

  setLocale = () => {
    const userPreferredLocale = userLocale();
    this.contentfulClient.getSpace()
      .then((space) => {
        const supportedLocaleCodes = space.locales.map(locale => locale.code);
        this.locale = this.includes(supportedLocaleCodes, userPreferredLocale) ? userPreferredLocale : this.locale;
      })
      .catch((error) => {
        console.log('Error fetching locales from Contentful: ', error);
      });
  };

  includes = (container, value) => {
    if (container.indexOf(value) >= 0) {
      return true;
    }
    return false;
  };

  getItems(type) {
    var that = this;
    var client = this.contentfulClient;
    const userPreferredLocale = userLocale();
    var promise = new Promise((resolve, reject) => {
      if (that.entries[type]) {
        resolve(that.entries[type]);
      } else {
        client.getEntries({
          'content_type': type,
          'locale': this.locale
        }).then(function (entries) {
          that.entries[type] = entries.items;
          resolve(entries.items);
        }).catch(function(e) {
          reject(e);
        });
      }
    });
    return promise;
  }

  _getMediaUrl(media){
    return 'https:' + media.fields.file.url;
  }
  
  _convertToTagsMap(tagsArray) {
      const that = this;
      return tagsArray.map(function (item) {
        const { tag, name, projectTypeTag, licenseName, description = "" } = item.fields;
        return {
          tag,
          name,
          description,
          filterKeys: projectTypeTag,
          licenseName,
          imageUrl: item.fields.image ? that._getMediaUrl(item.fields.image) : null,
        };
      });
  }

  _getIntents(type){
    const that=this;
    const promise=new Promise(function(resolve,reject){
      that.getItems(type).then(function(intentsArray){
        resolve(that._convertToTagsMap(intentsArray));
      }).catch(function(e) {
        reject(e);
      });
    });
    return promise;
  }

  getProjectTypes() {
    return this._getIntents('projectType');
  }

  getSourceTypes() {
    return this._getIntents('sourceType');
  }

  getUseCases() {
    const useCasesPromise = new Promise((resolve, reject) => {
      this.getItems('useCases')
        .then(response => {
          resolve(
            response.map(usecase => {
              return {
                id: usecase.sys.id,
                ...usecase.fields,
                videoUrl: usecase.fields.video ? this._getMediaUrl(usecase.fields.video) : null
              };
            })
          );
        })
        .catch(e => reject(e));
    });

    return useCasesPromise;
  }

  getLayout() {
    const layoutPromise = new Promise((resolve, reject) => {
      this.getItems('intentGateLayout')
        .then((items) => {
          resolve(items[0].fields);
        })
        .catch((e) => {
          reject(e);
        });
    });
    return layoutPromise;
  }
}

export default CmsService;